import {useState, useEffect} from 'react';

export default function useMediaQuery(query) {
    const mediaQuery = window.matchMedia(query instanceof Array ? query.join(', ') : query);

    const [matches, setMatches] = useState(mediaQuery.matches);

    useEffect(() => {
        mediaQuery.addEventListener('change', (event) => {
            setMatches(mediaQuery.matches);
        });
    }, []);

    return matches;
}
